import React, { useState } from 'react';
import { toast } from 'sonner';
import { Sparkle } from '@phosphor-icons/react';

const STORAGE_KEY = 'bx_aurora_opt_out';

/**
 * AuroraOptOutToggle — small switch on Profile. Defaults to "auroras on";
 * users who don't like the global tint can mute it. Setting persists in
 * localStorage; AuroraLayer reads from there.
 */
const AuroraOptOutToggle = () => {
  const [optedOut, setOptedOut] = useState(localStorage.getItem(STORAGE_KEY) === '1');

  const toggle = () => {
    const next = !optedOut;
    if (next) localStorage.setItem(STORAGE_KEY, '1');
    else localStorage.removeItem(STORAGE_KEY);
    setOptedOut(next);
    toast.success(next ? 'auroras muted everywhere' : 'auroras will sweep again');
    // Force a tiny refresh
    window.location.reload();
  };

  return (
    <div className="glass rounded-2xl p-5 mt-6" data-testid="aurora-opt-out">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-bx-legendary flex items-center gap-1">
            <Sparkle size={11} weight="fill" /> aurora drift events
          </div>
          <div className="font-display text-lg font-bold mt-1">
            {optedOut ? 'Auroras are muted' : 'Auroras sweep the whole app'}
          </div>
          <p className="text-xs text-white/55 mt-1">
            When a global Aurora Drift event fires, the entire app gets a soft glow. Visual only.
          </p>
        </div>
        <button onClick={toggle}
          data-testid="aurora-opt-out-toggle"
          className={`px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest ${
            optedOut ? 'glass-hi hover:bg-white/10' : 'bg-bx-legendary/20 text-bx-legendary hover:bg-bx-legendary/30'
          }`}>
          {optedOut ? 'turn on' : 'mute'}
        </button>
      </div>
    </div>
  );
};

export default AuroraOptOutToggle;
